import { buildAxiosClient } from '../../../../common/models/axiosClient';
import type { AxiosPromise } from 'axios';
import type { Condition } from './condition';

export class ConditionClient {
  updateNote(
    kyccId: number,
    conditionId: number,
    note: string,
  ): AxiosPromise<Condition> {
    return buildAxiosClient().put(
      `/api/v1/my/company/kyccs/${kyccId}/conditions/${conditionId}.json`,
      { condition: { note: note } },
    );
  }
}
